import { render, staticRenderFns } from "./InstockConfirm.vue?vue&type=template&id=fd40a9c4&"
import script from "./InstockConfirm.vue?vue&type=script&lang=js&"
export * from "./InstockConfirm.vue?vue&type=script&lang=js&"
import style0 from "./InstockConfirm.vue?vue&type=style&index=0&id=fd40a9c4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports